import httpClient from 'shared/lib/httpClient';
import { parseRoleList } from '../schemas/RoleSchema';

export const getRoleList = async (params) => {
  const response = await httpClient.get('/company-roles', { params });
  return parseRoleList(response?.data);
};
